// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "./App";
import router from "./router";
import Vuex from "vuex";
import ElementUI from "element-ui";

import "babel-polyfill"; //支持IE执行原生script

import "normalize.css/normalize.css"; // normalize.css 样式格式化
import "element-ui/lib/theme-chalk/index.css";
import "./assets/custom-theme/index.css"; // 换肤版本element-ui css

// import '@/css/commonnew.css'
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条 样式

// import 'assets/iconfont/iconfont'; // iconfont 具体图标见https://github.com/PanJiaChen/vue-element-admin/wiki
// import Multiselect from 'vue-multiselect';// 使用的一个多选框组件，element-ui的select不能满足所有需求
// import 'vue-multiselect/dist/vue-multiselect.min.css';// 多选框组件css
// import Sticky from 'components/Sticky'; // 粘性header组件
// import IconSvg from 'components/Icon-svg';// svg 组件
import vueWaves from "./directive/waves"; // 水波纹指令
// import errLog from 'store/errLog';// error log组件

import store from "./store";
import config from "../config/config.js";

Vue.use(vueWaves);
Vue.use(ElementUI);
Vue.use(Vuex);

//截取url中的数据
let tempStr = window.location.href;
let tempArr = tempStr.split("?")[1] ? tempStr.split("?")[1].split("&") : [];
// alert(tempArr);
let returnArr = {};
tempArr.forEach(element => {
  returnArr[element.split("=")[0]] = element.split("=")[1];
  console.log(returnArr);
});
if (
  returnArr.userId != null &&
  returnArr.userId != "" &&
  returnArr.userId != undefined
) {
  console.log(returnArr.userId);
  // let cs2 = {
  //   // "key":returnArr.userId
  //   "key":"bst",
  //   "value":"coxluv14zk8jleslj75uq7re7zj5xrup"
  // }
  // setKey(cs2).then(res => {
  //   console.log(res)
  //   if(res.data.resultCode === 2000){
  //     if(res.data.outmap.result != null && res.data.outmap.result != '' && res.data.outmap.result != undefined){
  //       // let cs3 = {
  //       //   "key":"bst",
  //       //   "expireTime":"10"
  //       // }
  //       // setKeyExpire(cs3).then(res => {
  //       // })
  //       setToken(res.data.outmap.result)
  //     }
  //   }
  // })

  sessionStorage.setItem("userId", returnArr.userId);
  console.log(sessionStorage.getItem("userId") + "ss");
  let cs = {
    key: returnArr.userId
  };
  getKey(cs).then(res => {
    console.log(res);
    if (res.data.resultCode === 2000) {
      if (
        res.data.outmap.result != null &&
        res.data.outmap.result != "" &&
        res.data.outmap.result != undefined
      ) {
        //  alert(res.data.outmap.result);
        setToken(res.data.outmap.result);
      }
    }
  });
}

// register global progress.
const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (
    !localStorage.getItem("partnerplan_access_token") &&
    to.path != "/login"
  ) {
    localStorage.clear();
    next("/login");
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

Vue.config.productionTip = false;

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js